import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查询任课老师教的选修班
  listTeacherElectiveClass(_postData) {
    return http.get(URL.API_ELECTIVE_TEACHER_CLASS_LIST, _postData)
  },
  // 查询学生端某个选课活动的选修班类型
  listElectiveClassType(_postData) {
    return http.get(URL.API_ELECTIVE_CLASSTYPES, _postData)
  },

  // 班級课表
  getCourseClassDetails(_postData) {
    return http.get(URL.API_SCHEDULE_CLASS_DETAILS, _postData)
  },
  // 课程班级信息-列表
  getCourseClassList(_postData) {
    return http.get(URL.API_SCHEDULE_CLASS_LIST, _postData)
  },
  // 教师课表
  getTeacherClassDetails(_postData) {
    return http.get(URL.API_SCHEDULE_TEACHER_DETAILS, _postData)
  },
  // 课程老师信息-列表
  getTeacherClassList(_postData) {
    return http.get(URL.API_SCHEDULE_TEACHER_LIST, _postData)
  },
  // 查询当前用户是否为任课老师
  isSquirrelTeacher(_postData) {
    return http.get(URL.API_SCHEDULE_IS_TEACHER, _postData)
  },
  // 班級课表
  getClassDetailsV2(_postData) {
    return http.get(URL.API_SCHEDULE_CLASS_DETAILS_V2, _postData)
  },
  // 教师课表
  getTeacherDetailsV2(_postData) {
    return http.get(URL.API_SCHEDULE_TEACHER_DETAILS_V2, _postData)
  },
  // 取消校历的设置
  schoolCalendarCancel(_postData) {
    return http.post(URL.API_H5_SCHOOL_CALENDAR_CANCEL, _postData)
  },
  // 批量获取日历信息
  schoolCalendarQueryList(_postData) {
    return http.post(URL.API_H5_SCHOOL_CALENDAR_QUERY_LIST, _postData)
  },
  // 将某一天设置成校历的休息日
  schoolCalendarRestDay(_postData) {
    return http.post(URL.API_H5_SCHOOL_CALENDAR_REST_DAY, _postData)
  },
  // 将某一天设置成校历的工作日
  schoolCalendarWorkDay(_postData) {
    return http.post(URL.API_H5_SCHOOL_CALENDAR_WORK_DAY, _postData)
  }
}
